import React from 'react';
import {SvgIcon} from '@website/components/shared/icons/SvgIcon';

export const ShareIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = 'text-black',
  strokeWidth = 1.5,
  fillColor = 'none',
  classes = '',
  title = 'Custom Icon',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 16 16"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <title>{title}</title>
    <g id="Group 467">
      <path
        id="Vector 232"
        d="M1 5.375V14.875H15V5.375"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 233"
        d="M4 5.125L8 1.125L12 5.125"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 234"
        d="M8 2.5V10.5"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
